import AddBox from '@mui/icons-material/AddBox';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Info from '@mui/icons-material/Info';
import LibraryBooks from '@mui/icons-material/LibraryBooks';
import Warning from '@mui/icons-material/Warning';
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    Tooltip,
    Typography
} from '@mui/material';
import { blue } from '@mui/material/colors';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import Configuracao from '../../util/Configuracao';
import NumeroProcesso from '../NumeroProcesso';
import ReactComponent from '../ReactComponent';
import { MEIO_JULGAMENTO_PROCESSO } from '@/dominio/MeioJulgamentoProcesso';
import { MODALIDADE_SESSAO_JULGAMENTO } from '@/dominio/ModalidadeSessaoJulgamento';

class IncluirProcessoSessao extends ReactComponent {
    timeoutConsultaProcesso;
    processando = false;
    openModalIncluirProcesso = false;
    numeroProcesso;
    sessaoSelecionada;
    pautaSelecionada;
    processoPautavel;
    detalhesProcesso;
    alertas = [];
    alertasImpeditivos = [];
    preparacaoPauta = 'false';

    abrirModalIncluirProcesso = () => {
        if (this.sessoes.length === 1) {
            this.carregarInformacoesPauta(this.sessoes[0]);
        }
        this.openModalIncluirProcesso = true;
    };

    fecharModalIncluirProcesso = () => {
        this.processando = false;
        this.openModalIncluirProcesso = false;
        this.numeroProcesso = undefined;
        this.processoPautavel = undefined;
        this.alertas = [];
        this.alertasImpeditivos = [];
    };

    callbackOnChangeNumeroProcesso = (numeroProcesso) => {
        this.numeroProcesso = numeroProcesso;
        this.carregarInformacoesProcesso();
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            timeoutConsultaProcesso: observable,
            processando: observable,
            openModalIncluirProcesso: observable,
            numeroProcesso: observable,
            sessaoSelecionada: observable,
            pautaSelecionada: observable,
            processoPautavel: observable,
            detalhesProcesso: observable,
            alertas: observable,
            alertasImpeditivos: observable,
            preparacaoPauta: observable,
            abrirModalIncluirProcesso: action,
            fecharModalIncluirProcesso: action,
            callbackOnChangeNumeroProcesso: action,
            isNumeroProcessoPreenchido: computed,
            carregarInformacoesProcesso: action,
            validarProcesso: action,
            validarMotivosProcessoInapto: action,
            verificarRemanescenteComPautaPublicada: action,
            verificarTarefaCorretaPje: action,
            isPautaPublicada: computed,
            dataPublicacaoPautaSelecionada: computed,
            dataInicioSessaoPresencial: computed,
            prazoPermiteIncluirEmPauta: computed,
            carregarAlertasInclusaoPauta: action,
            carregarMapaProcessoPartes: action,
            validarProcessoSessao: action,
            handleClickAbrirProcesso: action,
            carregarProcessoPautavel: action,
            carregarJulgamentosAnteriores: action,
            handleClickConfirmar: action,
            handleChangeSessao: action,
            isProcessoRemanescente: computed,
            desabilitarConfirmar: computed,
            exibirMensagem: computed,
            isSessaoPJeSelecionada: computed,
            isSessaoSIJSelecionada: computed,
            isSessaoFechada: computed,
            existeAlerta: computed,
            existeAlertaImpeditivo: computed,
            descricaoTipoInclusaoPauta: computed,
            julgamentosAnteriores: computed,
            handleChangePreparacaoPauta: action,
            isTarefaAtualAguardandoSessao: computed,
            desabilitaSelecaoPreparacaoPauta: computed,
            verificarTipoJulgamento: action,
            tipoJulgamentoSessao: computed,
            tipoJulgamentoInclusao: computed
        });
    }

    get isNumeroProcessoPreenchido() {
        return this.numeroProcesso && this.numeroProcesso.isPreenchido();
    }

    carregarInformacoesProcesso() {
        this.processoPautavel = undefined;
        this.alertas = [];
        this.alertasImpeditivos = [];
        if (this.sessaoSelecionada && this.isNumeroProcessoPreenchido) {
            if (this.timeoutConsultaProcesso) {
                clearTimeout(this.timeoutConsultaProcesso);
            }
            this.timeoutConsultaProcesso = setTimeout(
                () => this.validarProcesso(this.numeroProcesso.numeroFormatado()),
                500
            );
        }
    }

    validarProcesso = async (numeroProcesso) => {
        try {
            if (this.sessaoSelecionada && numeroProcesso) {
                let detalhes = await this.recuperarDetalhesProcesso(numeroProcesso);
                if (detalhes && this.validarProcessoSessao(numeroProcesso)) {
                    runInAction(() => (this.detalhesProcesso = detalhes));
                    this.carregarMapaProcessoPartes(detalhes);
                    await this.carregarProcessoPautavel(detalhes);
                    await this.carregarJulgamentosAnteriores(detalhes);
                    await this.carregarAlertasInclusaoPauta(detalhes);
                    await this.validarMotivosProcessoInapto(numeroProcesso);
                    this.verificarRemanescenteComPautaPublicada();
                    this.verificarTarefaCorretaPje();
                    this.verificarTipoJulgamento();
                }
            }
        } finally {
            runInAction(() => (this.timeoutConsultaProcesso = undefined));
        }
    };

    async validarMotivosProcessoInapto(numeroProcesso) {
        let motivosProcessoInapto = await this.sessaoService.validarMotivosProcessoInapto(
            this.sessaoSelecionada.id,
            numeroProcesso
        );
        if (motivosProcessoInapto && !motivosProcessoInapto.erro) {
            this.alertasImpeditivos = this.alertasImpeditivos.concat(
                motivosProcessoInapto.map((motivo) => motivo.motivoDetalhado)
            );
        }
    }

    verificarRemanescenteComPautaPublicada() {
        if (!this.isProcessoRemanescente && this.isPautaPublicada) {
            this.alertas.push(
                'AVISO: A pauta já foi publicada. Verifique se há prazo para aditamentos e(ou) intimações.'
            );
        }
    }

    verificarTarefaCorretaPje() {
        if (
            this.isSessaoPJeSelecionada &&
            this.detalhesProcesso &&
            this.detalhesProcesso.tarefaAtual !== 'Aguardando inclusão em pauta ou sessão' &&
            this.detalhesProcesso.tarefaAtual !== 'Aguardando sessão de julgamento'
        ) {
            this.alertasImpeditivos.push(
                "AVISO: O processo não está na tarefa 'Aguardando inclusão em pauta ou sessão' e encontra-se na tarefa '" +
                    this.detalhesProcesso.tarefaAtual +
                    "'."
            );
        }
    }

    verificarTipoJulgamento() {
        if (this.processoPautavel && this.processoPautavel.tipoJulgamento !== this.tipoJulgamentoInclusao) {
            this.alertas.push(
                'AVISO: O tipo de julgamento do processo ' +
                    this.processoPautavel.tipoJulgamento +
                    ' é incompatível com tipo de julgamento da sessão ' +
                    this.tipoJulgamentoSessao +
                    '. O processo será automaticamente ajustado para ' +
                    this.tipoJulgamentoInclusao +
                    '.'
            );
        }
    }

    get isPautaPublicada() {
        return moment(this.dataPublicacaoPautaSelecionada, 'DD-MM-YYYY-HH-mm-ss').isBefore(moment());
    }

    get dataPublicacaoPautaSelecionada() {
        const prazosSessao = this.sessaoStore.sessaoSelecionada.prazosPorSessao[this.sessaoSelecionada.id];
        return prazosSessao && prazosSessao.dataPublicacaoPauta;
    }

    get dataInicioSessaoPresencial() {
        const prazosSessao = this.sessaoStore.sessaoSelecionada.prazosPorSessao[this.sessaoSelecionada.id];
        return prazosSessao && prazosSessao.dataInicioSessaoPresencial;
    }

    get temVotacaoVirtual() {
        const prazosSessao = this.sessaoStore.sessaoSelecionada.prazosPorSessao[this.sessaoSelecionada.id];
        return prazosSessao && prazosSessao.dataInicioVotacaoVirtual && prazosSessao.dataFimVotacaoVirtual
            ? true
            : false;
    }

    get tipoJulgamentoSessao() {
        return this.sessaoStore.sessaoSelecionada.tipoJulgamento;
    }

    get tipoJulgamentoInclusao() {
        if (this.tipoJulgamentoSessao === this.processoPautavel?.tipoJulgamento) {
            return this.tipoJulgamentoSessao;
        }
        if (
            this.processoPautavel?.tipoJulgamento === MEIO_JULGAMENTO_PROCESSO.VIRTUAL.codigo &&
            this.temVotacaoVirtual
        ) {
            return MEIO_JULGAMENTO_PROCESSO.VIRTUAL.codigo;
        }
        return this.tipoJulgamentoSessao === MEIO_JULGAMENTO_PROCESSO.VIRTUAL.codigo ||
            this.tipoJulgamentoSessao === MEIO_JULGAMENTO_PROCESSO.PRESENCIAL.codigo
            ? this.tipoJulgamentoSessao
            : this.processoPautavel?.tipoJulgamento;
    }

    get prazoPermiteIncluirEmPauta() {
        return moment(this.dataInicioSessaoPresencial, 'DD-MM-YYYY-HH-mm-ss').isAfter(moment());
    }

    carregarAlertasInclusaoPauta(detalhes) {
        if (!this.alertasImpeditivos || this.alertasImpeditivos.length === 0) {
            let alertas = this.sessaoStore.getAlertasInclusaoPautaSessao(
                this.processoPautavel,
                detalhes,
                this.pautaSelecionada.composicaoPadrao
            );
            runInAction(() => (this.alertas = alertas));
        }
    }

    carregarMapaProcessoPartes(detalhes) {
        Object.assign(
            this.sessaoStore.mapaProcessosPartesSessao,
            this.store.getMapaProcessosPartes([detalhes], this.sessaoSelecionada.id)
        );
    }

    validarProcessoSessao(numeroProcesso) {
        let retorno =
            this.sessaoStore.sessaoSelecionada &&
            this.sessaoStore.sessaoSelecionada.processos &&
            this.sessaoStore.sessaoSelecionada.processos.findIndex(
                (registro) => registro.numeroProcesso === numeroProcesso
            ) === -1;
        if (!retorno) {
            this.alertasImpeditivos.push('O processo já está na sessão.');
        }
        return retorno;
    }

    handleClickAbrirProcesso = (numeroProcesso) => {
        this.fecharModalIncluirProcesso();
        this.salaSessaoStore.abrirProcessoPeloNumero(numeroProcesso);
    };

    async recuperarDetalhesProcesso(numeroProcesso) {
        let detalhes;
        try {
            let resultado = await this.processoService.recuperarDetalhesProcesso(
                numeroProcesso,
                this.sessaoSelecionada.origem,
                true
            );
            detalhes = resultado.data;
        } catch (error) {
            // @ts-ignore
            if (error && error.response && error.response.status === 404) {
                runInAction(() =>
                    this.alertasImpeditivos.push(
                        'Processo não encontrado no sistema de tramitação processual de origem.'
                    )
                );
            } else {
                this.errorStore.tratarRespostaErro(error);
            }
        }
        return detalhes;
    }

    async carregarProcessoPautavel(detalhes) {
        try {
            let response = await this.processoService.recuperarProcessoPautavel(
                this.sessaoSelecionada.id,
                detalhes.numeroCompleto,
                true
            );
            runInAction(() => {
                if (response && response.data) {
                    this.processoPautavel = response.data;
                    this.processoPautavel.processo.origem = this.sessaoSelecionada.origem;
                } else {
                    this.processoPautavel = undefined;
                }
            });
        } catch (error) {
            // @ts-ignore
            if (!error || !error.response || error.response.status !== 404) {
                this.errorStore.tratarRespostaErro(error);
            }
        }
    }

    async carregarJulgamentosAnteriores(detalhes) {
        if (this.isProcessoRemanescente) {
            let julgamentos = await this.processoService.recuperarJulgamentosAnteriores(
                detalhes.numeroCompleto,
                this.sessaoSelecionada.origem
            );
            runInAction(() => (this.processoPautavel.julgamentosAnteriores = julgamentos));
        }
    }

    handleClickConfirmar = async () => {
        try {
            this.processando = true;
            let retorno = await this.sessaoService.incluirProcesso(
                this.sessaoSelecionada.id,
                this.detalhesProcesso.numeroCompleto,
                this.preparacaoPauta,
                this.tipoJulgamentoInclusao
            );

            this.fecharModalIncluirProcesso();

            if (retorno && retorno.length > 0 && retorno[0]) {
                this.mensagemStore.abrirMensagemAlerta(`Processo incluído com alerta: ${retorno[0]}`);
            } else {
                this.mensagemStore.abrirMensagemSucesso('Processo incluído com sucesso.');
            }
        } finally {
            this.processando = false;
            this.salaSessaoStore.recarregarListaProcessos();
        }
    };

    handleChangeSessao = async (event) => {
        await this.carregarInformacoesPauta(event.target.value);
        this.carregarInformacoesProcesso();
    };

    async carregarInformacoesPauta(sessaoSelecionada) {
        let pauta;
        if (sessaoSelecionada) {
            pauta = await this.sessaoService.recuperarPautaJulgamento(sessaoSelecionada.id);
        }
        runInAction(() => {
            this.sessaoSelecionada = sessaoSelecionada;
            this.pautaSelecionada = pauta;
        });
    }

    get isProcessoRemanescente() {
        return this.processoPautavel && this.processoPautavel.tipoInclusao === 'REMANESCENTE';
    }

    get sessoes() {
        return this.salaSessaoStore.sessoesSessaoSelecionada;
    }

    get desabilitarConfirmar() {
        return !this.isNumeroProcessoPreenchido || !this.sessaoSelecionada || !this.detalhesProcesso;
    }

    get exibirMensagem() {
        return this.timeoutConsultaProcesso === undefined && !this.desabilitarConfirmar && !this.existeAlertaImpeditivo;
    }

    get isSessaoPJeSelecionada() {
        return this.sessaoSelecionada && this.sessaoSelecionada.origem === Configuracao.ORIGEM_PJE;
    }

    get isSessaoSIJSelecionada() {
        return this.sessaoSelecionada && this.sessaoSelecionada.origem === Configuracao.ORIGEM_SIJ;
    }

    get isSessaoFechada() {
        // Apenas PJe
        return (
            this.salaSessaoStore.sessaoSelecionada &&
            this.salaSessaoStore.sessaoSelecionada.situacao === Configuracao.STATUS_FECHADA
        );
    }

    get todosAlertas() {
        return this.alertasImpeditivos.concat(this.alertas);
    }

    get existeAlerta() {
        return this.alertas && this.alertas.length > 0;
    }

    get existeAlertaImpeditivo() {
        return this.isNumeroProcessoPreenchido && this.alertasImpeditivos && this.alertasImpeditivos.length > 0;
    }

    get descricaoTipoInclusaoPauta() {
        let retorno = '';
        if (this.processoPautavel?.tipoInclusao) {
            let tipoInclusaoPauta = this.dominioStore.tiposInclusaoPauta.find(
                (tipo) => tipo.tipoInclusao === this.processoPautavel.tipoInclusao
            );
            retorno = tipoInclusaoPauta ? tipoInclusaoPauta.descricao : '';
        }
        return retorno;
    }

    get julgamentosAnteriores() {
        return this.processoPautavel?.julgamentosAnteriores || [];
    }

    handleChangePreparacaoPauta = (event) => {
        this.preparacaoPauta = event.target.value;
    };

    get isTarefaAtualAguardandoSessao() {
        return this.detalhesProcesso && this.detalhesProcesso.tarefaAtual === 'Aguardando sessão de julgamento';
    }

    get desabilitaSelecaoPreparacaoPauta() {
        return this.isSessaoPJeSelecionada && this.isTarefaAtualAguardandoSessao;
    }

    render() {
        if (!this.isComponenteHabilitado('IncluirProcessoSessao') || this.isSessaoFechada) {
            return null;
        }
        return (
            <div
                style={{ display: 'flex', cursor: 'pointer', fill: this.observableProps.corIcone }}
                className="corBotaoAmarelo"
            >
                <Tooltip
                    title={'Incluir processo na sessão'}
                    placement="top-start"
                    className="corBotao"
                >
                    <Box onClick={this.abrirModalIncluirProcesso}>
                        <AddBox
                            style={{ width: '24px', height: '24px', margin: '8px', fill: 'white', paddingTop: '4px' }}
                        />
                    </Box>
                </Tooltip>
                {this.openModalIncluirProcesso && (
                    <Dialog
                        open
                        fullWidth
                        maxWidth="md"
                        onClose={this.fecharModalIncluirProcesso}
                        PaperProps={{ style: { minHeight: '45%' } }}
                    >
                        <DialogTitle>Incluir processo na sessão</DialogTitle>
                        {this.renderDialogContent()}
                        {this.renderDialogActions()}
                    </Dialog>
                )}
            </div>
        );
    }

    renderDialogContent() {
        return (
            <DialogContent style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                <div style={{ display: 'flex', alignItems: 'baseline' }}>
                    <Typography
                        variant="subtitle2"
                        color="inherit"
                        sx={{ mr: 2 }}
                    >
                        Sessão
                    </Typography>
                    <Select
                        style={{ minWidth: '200px', marginBottom: '10px', marginRight: '48px' }}
                        value={this.sessaoSelecionada || ''}
                        onChange={this.handleChangeSessao}
                    >
                        {this.sessoes.map(
                            (sessao) =>
                                sessao?.descricao && (
                                    <MenuItem
                                        key={this.nextKey}
                                        value={sessao}
                                    >
                                        {sessao.descricao}
                                    </MenuItem>
                                )
                        )}
                    </Select>
                    <Typography
                        variant="subtitle2"
                        color="inherit"
                        sx={{ ml: 3, mr: 2 }}
                    >
                        Processo
                    </Typography>
                    <NumeroProcesso
                        callbackOnChange={this.callbackOnChangeNumeroProcesso}
                        clickLimpar={this.callbackOnChangeNumeroProcesso}
                    />
                </div>
                {this.timeoutConsultaProcesso ? (
                    <div style={{ marginTop: '16px', display: 'flex', alignItems: 'flex-start', flexGrow: 1 }}>
                        <CircularProgress
                            size={20}
                            style={{ marginRight: '16px' }}
                        />
                        <div>Carregando informações do processo</div>
                    </div>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                        {this.renderAlertas()}
                        {this.renderTipoInclusaoPauta()}
                    </div>
                )}
                {this.exibirMensagem && (
                    <h5 style={{ marginBottom: '0px' }}>
                        <RadioGroup
                            value={this.preparacaoPauta}
                            onChange={this.handleChangePreparacaoPauta}
                            style={{ display: 'flex', flexDirection: 'row', flexGrow: 1, marginLeft: '10px' }}
                        >
                            <FormControlLabel
                                label="Incluir na pauta de julgamento"
                                value={'true'}
                                control={<Radio />}
                                style={{ marginRight: '60px', width: '300px' }}
                                disabled={!this.prazoPermiteIncluirEmPauta || this.desabilitaSelecaoPreparacaoPauta}
                            />
                            <FormControlLabel
                                label="Incluir diretamente na sessão de julgamento"
                                value={'false'}
                                control={<Radio />}
                                style={{ marginRight: '60px' }}
                                disabled={this.desabilitaSelecaoPreparacaoPauta}
                            />
                        </RadioGroup>
                        {this.isSessaoPJeSelecionada && (
                            <Typography>
                                Certifique-se de que este processo se encontra na tarefa correta e que o Relator
                                participa da composição da sessão.
                            </Typography>
                        )}
                    </h5>
                )}
            </DialogContent>
        );
    }

    renderAlertas() {
        return (
            (this.existeAlerta || this.existeAlertaImpeditivo) && (
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px' }}>
                    <div style={{ alignSelf: 'flex-start' }}>
                        <Warning style={{ fill: 'darkorange', marginRight: '16px' }} />
                    </div>
                    <div>
                        {this.todosAlertas.map((alerta) => (
                            <div
                                key={this.nextKey}
                                style={{ lineHeight: '1.5', marginBottom: '8px' }}
                            >
                                {alerta}
                            </div>
                        ))}
                    </div>
                </div>
            )
        );
    }

    renderTipoInclusaoPauta() {
        return (
            this.processoPautavel && (
                <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, marginTop: '16px' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <LibraryBooks style={{ marginRight: '16px' }} />
                        {this.descricaoTipoInclusaoPauta}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            flexGrow: '1',
                            overflowY: 'auto',
                            height: '100%'
                        }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '40px', maxHeight: '20px' }}>
                            <ul style={{ listStyleType: 'none' }}>
                                {this.julgamentosAnteriores.map((sessao) => (
                                    <li
                                        key={this.nextKey}
                                        style={{ display: 'flex', alignItems: 'center' }}
                                    >
                                        <Info style={{ fill: blue[400], marginRight: '8px' }} />
                                        <div>
                                            {sessao.descricaoResultadoJulgamento +
                                                ' (' +
                                                moment(sessao.dataJulgamento, 'DD-MM-YYYY-HH-mm-ss').format(
                                                    'DD/MM/YYYY'
                                                ) +
                                                ')'}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            )
        );
    }

    renderDialogActions() {
        return (
            <DialogActions sx={{ mt: 2, ml: 3, mr: 3, mb: 2 }}>
                <Button
                    onClick={this.fecharModalIncluirProcesso}
                    variant="outlined"
                    color="secondary"
                    endIcon={<CancelIcon />}
                    disabled={this.processando}
                >
                    Cancelar
                </Button>
                <Tooltip
                    title={this.desabilitarConfirmar ? 'Informe a sessão de julgamento e o número do processo' : ''}
                    placement="top"
                >
                    <span>
                        <Button
                            onClick={this.handleClickConfirmar}
                            variant="contained"
                            color="primary"
                            endIcon={<AddCircleIcon />}
                            disabled={
                                this.processando ||
                                this.timeoutConsultaProcesso !== undefined ||
                                this.desabilitarConfirmar ||
                                this.existeAlertaImpeditivo
                            }
                        >
                            Incluir
                        </Button>
                    </span>
                </Tooltip>
            </DialogActions>
        );
    }
}

export default inject('stores')(observer(IncluirProcessoSessao));
